import {
  CompoundUnitInputField,
  CompoundUnitInputFieldProps,
  Typography,
} from '@vartanainc/design-system';
import { useField } from 'formik';
import { debounce } from 'lodash';
import { forwardRef, useMemo } from 'react';
import './compactField.scss';

interface SubsidyFieldProps extends CompoundUnitInputFieldProps {
  isCompact?: boolean;
  errorMessage?: string;
  selectEnabled?: boolean;
}

const SubsidyField = forwardRef(
  ({
    id,
    name = '',
    label,
    type,
    options,
    className = '',
    isCompact = true,
    errorMessage,
    selectEnabled,
    onKeyDown,
    ...rest
  }: SubsidyFieldProps) => {
    const [field, , { setValue }] = useField(name);

    // Debounce the setValue function
    const debouncedSetValue = useMemo(() => debounce(setValue, 800), [setValue]);

    function getBorderClassName(showError?: boolean, disabled?: boolean): string {
      if (disabled) {
        if (isCompact) return 'disabled-border-compact';
        return 'disabled-border';
      }
      if (showError) {
        return 'error-border';
      }
      return '';
    }

    const getCompactClass = (isCompactFlag: boolean): string =>
      isCompactFlag ? 'compact-compound-unit-field' : 'not-compact';

    return (
      <>
        <CompoundUnitInputField
          {...rest}
          {...field}
          id={id}
          name={name}
          label={label}
          options={options}
          selectEnabled={selectEnabled}
          onValueChange={(e) => debouncedSetValue(e.value)}
          onKeyDown={onKeyDown}
          className={`${className} ${getCompactClass(isCompact)} ${getBorderClassName(
            rest.showError,
            rest.disabled
          )}`}
        />
        {errorMessage && (
          <Typography color="color-red-160" variant="paragraph10">
            {errorMessage}
          </Typography>
        )}
      </>
    );
  }
);

export default SubsidyField;
